const hideItemPanel = () => {
  let panelContainer = document.querySelector('.panelContainer');
    panelContainer.innerHTML = '';
};

export default hideItemPanel;
